import { render, staticRenderFns } from "./MaterrialVideo.vue?vue&type=template&id=1827ac6b&scoped=true&"
import script from "./MaterrialVideo.vue?vue&type=script&lang=js&"
export * from "./MaterrialVideo.vue?vue&type=script&lang=js&"
import style0 from "./MaterrialVideo.vue?vue&type=style&index=0&id=1827ac6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1827ac6b",
  null
  
)

export default component.exports